export enum RugbyUnionStatId {
  YellowCards = 8,
  RedCards = 9,
  PointsScored = 595,
  Tries = 400,
  DropGoals = 401,
  Conversions = 402,
  PenaltyTries = 1646,
  ConversionsMissed = 1647,
  ConversionAttempts = 1648,
  PenaltyKickGoals = 1649,
  PenaltyKicksMissed = 1650,
  PenaltiesAwarded = 1651,
  DropGoalsMissed = 1652,
  EntriesIntoTwentyTwo = 1653,
  KickPasses = 1654,
  FiftyTwentyTwoKicks = 1655,
  TurnoversConceded = 1656,
  TurnoversWon = 1657,
  Offloads = 1658,
  Rucks = 1659,
  RucksWon = 1660,
  RucksLost = 1661,
  RucksEfficiency = 1662,
  Mauls = 1663,
  MaulsWon = 1664,
  MaulsLost = 1665,
  MaulsEfficiency = 1666,
  Scrums = 1667,
  ScrumsWon = 1668,
  ScrumsLost = 1669,
  ScrumsEfficiency = 1670,
  LineOuts = 1671,
  LineOutsWon = 1672,
  LineOutsLost = 1673,
  LineOutsEfficiency = 1674,
  OrangeCards = 1675,
  TacklesMade = 1676,
  FreeKicks = 25,
  Fouls = 22,
  BallPossession = 770,
  BallPossessionPercentage = 771,
}
